import React from "react";

import { ReceiptsTable } from "../ReceiptsTable/ReceiptsTable";

import "./ReceiptsView.scss";

export function ReceiptsView() {
  return (
    <div className="receipts-view">
      <div className="receipts-view-header">
        <h1 className="receipts-view-title">Driver Receipts</h1>
      </div>
      <ReceiptsTable />
    </div>
  );
}
